import React, { useState, useEffect } from "react";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";
import ValidatePan from "./ValidatePan";
import ActiveUserInfo from "./ActiveUserInfo";
import CheckPrevRequest from "./CheckPrevRequest";
import SegmentModification from "./SegmentModification";
import IncomeModification from "../IncomeModifications/IncomeModification";
import SegmentModificationReason from "./SegmentModificationReason";
import SegmentModificationReview from "./SegmentModificationReview";
import SegmentModificationESignature from "./SegmentModificationESignature";
import DematUccForm from "../DematUccForm";
import {
  getRequestTypeDocs,
  getUccDematDetailApi,
  segmentUccDematApi,
} from "designs/v1/pages/ModifyKyc/services";

const SegmentModifications = ({ stageScreen, setStageScreen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState("ValidatePan");
  const [isContinue, setIsContinue] = useState(false);
  const [activeUserDetail, setActiveUserDetail] = useState(null);

  useEffect(() => {
    const requestType = getRequestTypeDocs();
    const loadUccDematDetail = async () => {
      const payload = {
        document_name: requestType[0],
      };
      try {
        const resp = await getUccDematDetailApi(payload);
        const data = resp.data?.data;
        handleUccDemat(data);
      } catch (err) {
        console.log("err", err);
      }
    };
    if (requestType?.length && step === "DematUccForm") {
      loadUccDematDetail();
    }
  }, [step]);

  const handleBack = () => setStep("ActiveUserInfo");

  const handleUccDemat = async (formVal) => {
    setIsLoading(true);
    const payload = {
      request_type: stageScreen,
      document_name: localStorage.getItem("SegmentRequestNumber"),
      ...formVal,
    };
    try {
      const resp = await segmentUccDematApi(payload);
      console.log("resp", resp);
      setIsLoading(false);
      setStep("SegmentModification");
    } catch (error) {
      console.log("err", error);
      setIsLoading(false);
    }
  };

  const getStepScreen = (step) => {
    let html = null;
    switch (step) {
      case "ValidatePan":
        html = (
          <ValidatePan
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setActiveUserDetail={setActiveUserDetail}
          />
        );
        break;
      case "ActiveUserInfo":
        html = (
          <ActiveUserInfo
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "CheckPrevRequest":
        html = (
          <CheckPrevRequest
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            setIsContinue={setIsContinue}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "DematUccForm":
        html = (
          <DematUccForm
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            handleBack={handleBack}
            handleSubmit={handleUccDemat}
            showDemat={false}
          />
        );
        break;
      case "SegmentModification":
        html = (
          <SegmentModification
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isContinue={isContinue}
            setIsContinue={setIsContinue}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "IncomeModification":
        html = (
          <IncomeModification
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isContinue={isContinue}
            setIsContinue={setIsContinue}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
            isSegment
          />
        );
        break;
      case "SegmentModificationReason":
        html = (
          <SegmentModificationReason
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isContinue={isContinue}
            setIsContinue={setIsContinue}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "SegmentModificationReview":
        html = (
          <SegmentModificationReview
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "SegmentModificationESignature":
        html = (
          <SegmentModificationESignature
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      default:
        break;
    }
    return html;
  };
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      {getStepScreen(step)}
    </React.Fragment>
  );
};

export default SegmentModifications;
